import { FlightSerie } from "../objects/flightSerie";
import { ManualFlight } from "../objects/manualFlight";

export const regroupManualFlight = (manual_flights: ManualFlight[]): FlightSerie[] => {
    const flight_series: FlightSerie[] = manual_flights.map((flight) => ({
        date: new Date(flight.segments[0].start_date),
        total_stock: flight.total_stock,
        total_stock_error: '',
        pnr_number: flight.pnr_number,
        pnr_number_error: '',
        purchase_price_adult: flight.purchase_price_adult,
        purchase_price_infant: flight.purchase_price_infant,
        purchase_price_child: flight.purchase_price_child,
        price_adult: flight.price_adult,
        price_infant: flight.price_infant,
        price_child: flight.price_child,
        taxes_adult: flight.taxes_adult,
        taxes_infant: flight.taxes_infant,
        taxes_child: flight.taxes_child,
        purchase_price_adult_error: '',
        purchase_price_infant_error: '',
        purchase_price_child_error: '',
        price_adult_error: '',
        price_infant_error: '',
        price_child_error: '',
        taxes_adult_error: '',
        taxes_infant_error: '',
        taxes_child_error: '',
        retrocession_date_date_error: '',
        retrocession_date_date: flight.retrocession_date_date? new Date(flight.retrocession_date_date): null,
        retrocession_date_type: flight.retrocession_date_date? 'DATE': 'NUMBER',
        retrocession_date_number: flight.retrocession_date_number,
        id: flight.id,
        quantity_used: flight.quantity_used
    }));

    return flight_series;
};